export const normalizeForumCommentId = (value) => {
  if (value === undefined || value === null || value === '') return '';
  const text = String(value);
  return /^[1-9]\d*$/.test(text) ? text : '';
};

export const getForumMessageTarget = (message = {}) => {
  const mainCommentId = normalizeForumCommentId(message.mainCommentId);
  const parentCommentId = normalizeForumCommentId(message.parentCommentId);
  if (!mainCommentId || !parentCommentId) return null;
  return { mainCommentId, parentCommentId };
};

export const getForumMessageTargetQuery = (message = {}) => {
  const target = getForumMessageTarget(message);
  return target
    ? { mainCommentId: target.mainCommentId, parentCommentId: target.parentCommentId }
    : undefined;
};
